import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { hrRequests } from "../../api/hr";
import { ApprovalCard } from "./ApprovalCard";
import { TimeOffApprovals } from "./TimeOffApprovals";
import { LeaveResumeApprovals } from "./LeaveResumeApprovals";

export const ApprovalsSection = ({ kinds = null }) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  const load = async () => setData(await hrRequests("pending"));
  useEffect(() => {
    load();
  }, []);

  if (!data) return null;
  const has = (k) => !kinds || kinds.includes(k);
  const advances = has("advance") ? data.advances || [] : [];
  const leaves = has("leave") ? data.leaves || [] : [];
  const resignations = has("resignation") ? data.resignations || [] : [];
  const total = advances.length + leaves.length + resignations.length;

  return (
    <div className="grid gap-4" data-testid="approvals-section">
      {has("timeOff") ? <TimeOffApprovals /> : null}
      {has("resume") ? <LeaveResumeApprovals /> : null}
      {!total ? (
        <p className="text-sm text-muted-foreground" data-testid="approvals-empty">
          {t("approvals.empty")}
        </p>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {advances.map((item) => (
            <ApprovalCard key={item.id} kind="advances" item={item} reload={load} />
          ))}
          {leaves.map((item) => (
            <ApprovalCard key={item.id} kind="leaves" item={item} reload={load} />
          ))}
          {resignations.map((item) => (
            <ApprovalCard key={item.id} kind="resignations" item={item} reload={load} />
          ))}
        </div>
      )}
    </div>
  );
};
